module.exports = __webpack_public_path__ + "media/images/lb/375-710e8bd87183ad5e410dd6f321e581b4.svg";